import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import Home from './Home';

const KeepMigration = lazy(() => import('./KeepMigration'));
const StartMigration = lazy(() => import('./StartMigration'));
const Login = lazy(() => import('./Login'));
const Register = lazy(() => import('./Register'));
const Settings = lazy(() => import('./Settings'));
const MigrationStatus = lazy(() => import('./MigrationStatus'));
const Blog = lazy(() => import('./Blog'));
const BlogPost = lazy(() => import('./BlogPost'));
const ConnectedStores = lazy(() => import('./ConnectedStores'));
const TermsOfService = lazy(() => import('./TermsOfService'));
const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'));
const ForgotPassword = lazy(() => import('./ForgotPassword'));
const ResetPassword = lazy(() => import('./ResetPassword'));
const VerifyEmail = lazy(() => import('./VerifyEmail'));
const AdminPanel = lazy(() => import('./AdminPanel'));
const NotFound = lazy(() => import('./NotFound'));

function PageLoadingFallback() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <CircularProgress />
    </Box>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<PageLoadingFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/start-migration" element={<StartMigration />} />
            <Route path="/keep-migration" element={<KeepMigration />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/migration-status" element={<MigrationStatus />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/magazalarim" element={<ConnectedStores />} />
            <Route path="/kullanim-sartlari" element={<TermsOfService />} />
            <Route path="/gizlilik-politikasi" element={<PrivacyPolicy />} />
            <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
            <Route path="/sifre-sifirla" element={<ResetPassword />} />
            <Route path="/e-posta-dogrula" element={<VerifyEmail />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
